import { render, staticRenderFns } from "./Welcomebox.vue?vue&type=template&id=c61a05a0&"
import script from "./Welcomebox.vue?vue&type=script&lang=js&"
export * from "./Welcomebox.vue?vue&type=script&lang=js&"
import style0 from "./Welcomebox.vue?vue&type=style&index=0&id=c61a05a0&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports